import './App.css';
import React, { useEffect } from 'react';
import AppRoutes from './Routes/AppRoutes';
import { ThemeProvider } from '@mui/material';
import { theme } from './Utils/theme';
import { ConfigProvider } from 'antd';
import { antTheme } from './Utils/antTheme';
import { AppColors } from './Utils/helper/AppColors';
import { Toaster } from 'react-hot-toast';
import CultService from './Services/CultService';
import { setCompany, setUser } from './store/reducers/appActions';
import { useDispatch } from 'react-redux';
import DynamicThemeProvider from './theme/Customtheme.js';
import { getColorSettings } from './Utils/helper/commonUtils.js';

function App() {
	const dispatch = useDispatch();
	const getUserDetails = async () => {
		let user = await CultService.getUserById({ params: { id: localStorage.getItem('userId') } });
		if (user.status == 200) {
			localStorage.setItem('user', JSON.stringify(user?.data?.data));
			dispatch(setUser(user?.data?.data));
			dispatch(setCompany(user?.data?.data?.company));
		}
	};

	useEffect(() => {
		const userId = localStorage.getItem('userId');
		if (userId) {
			getUserDetails();
		}
	}, []);

	const localSettingColors = getColorSettings();

	
	return (
		// ThemeProvider to apply custom theme for Material UI
		// <ThemeProvider theme={theme}>
		<DynamicThemeProvider>
			<Toaster
				toastOptions={{
					style: { minWidth: 'fit-content' },
					success: {
						iconTheme: {
							primary: AppColors?.green,
							secondary: '#FFFFFF',
						},
					},
				}}
			/>

			{/* // Ant Design ConfigProvider to apply custom theme */}
			<ConfigProvider
				theme={{
					token: {
						colorPrimary: AppColors?.orange || '#7F56D9',
						colorPrimaryHover: AppColors?.tomato_orange || AppColors.PRIMARY_DARK,
					},
					components: {
						Button: {
							controlHeight: 40,
							borderRadius: 8,
							fontWeight: 500,
							defaultBorderColor: localSettingColors.quaternary,
							defaultHoverBorderColor: AppColors.BLACK,
							defaultHoverColor: AppColors.BLACK,
							defaultHoverBg: '#f9f9f9',
						},
						Tag: {
							colorBgContainer: 'red',
							borderRadius: '50px !important',
						},
						DatePicker: {
							colorBorder: AppColors.orange || localSettingColors.quaternary,
							defaultHoverBorderColor: AppColors.orange || localSettingColors.quaternary,
							onHover: {
								colorBorder: AppColors.orange || localSettingColors.quaternary,
							},
							borderRadius: 8,
							controlHeight: 40,
						},
						Select: {
							colorBorder: AppColors.light_grey || localSettingColors.quaternary,
							colorBorderHover: AppColors.light_grey || localSettingColors.buttonBackground,
							colorBgContainer: AppColors.lightest_grey || '#fef3dc' || localSettingColors.quinary,
							colorText: AppColors.midnight_black || localSettingColors.fontColor,
							borderRadius: 8,
							controlHeight: 40,
							fontSize: 16,
							// colorTextPlaceholder: '#a2a2a2',
						},
					},
				}}
			>
				<AppRoutes />
			</ConfigProvider>
		</DynamicThemeProvider>
		/* </ThemeProvider> */
	);
}

export default App;
